<template>
  <v-app id="inspire">
    <v-content>
      <v-container
              class="fill-height"
              fluid
      >
        <v-row
                align="center"
                justify="center"
        >
          <v-col
                  cols="12"
                  sm="8"
                  md="4"
          >
            <v-card class="elevation-12" :loading="loading" loader-height="16">
              <v-toolbar
                      color="primary"
                      dark
                      flat
              >
                <v-toolbar-title>COVID19 Checker</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text>
                <ask-age v-if="age === null" @ageDefined="defineAge"></ask-age>
                <ask-sex v-else-if="sex === null" @sexDefined="defineSex"></ask-sex>
                <single-question v-else-if="question && question.type === 'single'"
                                 @evidenceDefined="addEvidence"
                                 :text="question.text"
                                 :items="question.items">
                </single-question>
                <group-single-question v-else-if="question && question.type === 'group_single'"
                                       @evidenceDefined="addEvidence"
                                       :text="question.text"
                                       :items="question.items">
                </group-single-question>
                <group-multiple-question v-else-if="question && question.type === 'group_multiple'"
                                         @evidenceDefined="addMultiEvidence"
                                         :text="question.text"
                                         :items="question.items">
                </group-multiple-question>
                <triage v-else-if="shouldStop"
                        @loading="loading = true"
                        @doneLoading="loading = false"
                        :age="age"
                        :sex="sex"
                        :evidence="evidence">
                </triage>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import askAge from './components/AskAge.vue';
import askSex from './components/AskSex.vue';
import singleQuestion from './components/SingleQuestion.vue';
import groupSingleQuestion from './components/GroupSingleQuestion.vue';
import GroupMultipleQuestion from './components/GroupMultipleQuestion.vue';
import Triage from './components/Triage.vue';
import {diagnosis} from "./infermedica";

export default {
  name: 'App',
  components: {
    askAge, askSex, singleQuestion, groupSingleQuestion, GroupMultipleQuestion, Triage
  },
  methods: {
    defineAge(age) {
      this.age = age;
    },
    defineSex(sex) {
      this.sex = sex;
      this.diagnosis();
    },
    addEvidence(evidence) {
      this.evidence.push(evidence);
      this.diagnosis();
    },
    addMultiEvidence(evidences) {
      this.evidence = this.evidence.concat(evidences);
      this.diagnosis();
    },
    async diagnosis() {
      this.loading = true;
      const {question, should_stop} = await diagnosis(this.age, this.sex, this.evidence);
      this.question = question;
      this.shouldStop = should_stop;
      this.loading = false;
    }
  },
  data: () => ({
    age: null,
    sex: null,
    evidence: [],
    loading: false,
    question: null,
    shouldStop: false,
  }),
};
</script>
